/* import __COLOCATED_TEMPLATE__ from './no-custom-objects-select-item.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();